import React, { useState } from "react";

function CommonHeader({ toggleSearchForm }) {
  const [showSearchForm, setShowSearchForm] = useState(false);

  const handleToggleSearchForm = () => {
    setShowSearchForm((prevState) => !prevState);
  };

  return (
    <div>
      <button className="search-icon" onClick={handleToggleSearchForm}>
        <i className="fas fa-search"></i>
      </button>
      <div
        className={`header-search-form ${showSearchForm ? "search-in" : ""}`}
      >
        <div className="container">
          <div className="header-search-container">
            <form className="search-form" role="search" method="get">
              <input type="text" name="s" placeholder="Enter your text..." />
            </form>
            <a
              href="."
              className="search-close"
              onClick={handleToggleSearchForm}
            >
              <i className="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Rest of your component code goes here */}
    </div>
  );
}

export default function Header() {
  return <CommonHeader toggleSearchForm={() => {}} />;
}
